import { CardActions, CardOverflow } from "@mui/joy";

import React, { useRef } from "react";

import { Toast } from "primereact/toast";
import { RouteComponentProps } from "../../../models/RouteComponent";

import { Button } from "primereact/button";
import { getDSFPDF } from "../../../service/formService";
import { dsfItems } from "../../../constantsAndDefaults/constants";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import { TabPanel, TabView } from "primereact/tabview";
import { Card } from "primereact/card";
import { Grid } from "@mui/material";
import SiteDsfBadgeCode from "../../../components/site-dsf-badge/SiteDsfBadgeCode";

export default function SiteDSFTable(props: RouteComponentProps) {
  const toast = useRef(null as any);
  const navigate = useNavigate();

  const session = props.session;
  const client_id = session.client_id;
  const site_id = session.site_id;

  let url = ``;

  if (process.env.REACT_APP_ENV === `production`) {
    url = `https://pwa.digitalsafetyfiles.com/dsf/${site_id}/`;
  } else {
    url = `https://develop.dlbghfb9e2vct.amplifyapp.com/dsf/${site_id}/`;
  }

  let link = ``;

  if (process.env.REACT_APP_ENV === `production`) {
    link = `https://pwa.digitalsafetyfiles.com/dsf/${site_id}/`;
  } else {
    link = `https://develop.dlbghfb9e2vct.amplifyapp.com/dsf/${site_id}/`;
  }

  async function downloadPDF() {
    props.setGlobalLoader(true);
    getDSFPDF()
      .then((r: any) => {
        console.log("getDSFPDF == ", r);
        window.open(r?.s3Key, "_blank");
        props.setGlobalLoader(false);
      })
      .catch(error => {
        props.setGlobalLoader(false);
      });
  }

  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(link);
    toast.current.show({
      severity: "success",
      summary: "Link copied to clipboard",
      life: 3000,
    });
  };

  return (
    <React.Fragment>
      <CardOverflow
        style={{ width: "100%" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          {/* <Button
            name="button"
            icon="pi pi-save"
            label="Download PDF"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => downloadPDF()}
          /> */}
          <Button
            name="button"
            icon="pi pi-copy"
            label="Copy Link"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => copyLinkToClipboard()}
          />
        </CardActions>
      </CardOverflow>
      <iframe src={url} style={{ width: '100%', height: '100%', border: 'none', marginTop: 25 }} title="DSF Viewer"></iframe>
      {/* <div className={"responsive-grid-4 py-4"}>
        {dsfItems.map((item, index) => {
          return (
            <div
              className={`custom-card ${item.disabled ? "disabled" : ""}`}
              key={index}
              onClick={() => {
                navigate("/site-dsf-table" + item.route);
              }}
            >
              <img
                src={`dsf/${item.icon}`}
                style={{ width: "50px", height: "auto" }}
                alt={item.label}
              />

              {item.label}
            </div>
          );
        })}
      </div> */}
      {/* <TabView>
        <TabPanel header="DSF">

          <CardOverflow
            style={{ width: "100%" }}
          >
            <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
              <Button
                name="button"
                icon="pi pi-save"
                label="Download PDF"
                className="p-button-outlined"
                size="small"
                style={{
                  position: "absolute",
                  fontSize: "small",
                  right: 0,
                  color: "#2dd36f",
                }}
                onClick={() => downloadPDF()}
              />
            </CardActions>
          </CardOverflow>
          <div className={"responsive-grid-4 py-4"}>
            {dsfItems.map((item, index) => {
              return (
                <div
                  className={`custom-card ${item.disabled ? "disabled" : ""}`}
                  key={index}
                  onClick={() => {
                    navigate("/site-dsf-table" + item.route);
                  }}
                >
                  <img
                    src={`dsf/${item.icon}`}
                    style={{ width: "50px", height: "auto" }}
                    alt={item.label}
                  />

                  {item.label}
                </div>
              );
            })}
          </div>
        </TabPanel>
        <TabPanel header="QR Poster">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SiteDsfBadgeCode company_logo_s3_key={session.client_logo_s3_key} client_id={client_id} site_id={site_id} site_name={session.site_name} toast={toast} />
              </Grid>
            </Grid>
          </Card>
        </TabPanel>
      </TabView> */}

      <Toast ref={toast} />
    </React.Fragment>
  );
}
